import React from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import HomeBannerSlide from 'components/admin/views/content/HomeBannerSlide';
import Faq from 'components/admin/views/content/Faq';
import HomeItems from 'components/admin/views/content/HomeItems';

import Blog from 'components/admin/views/content/blog/Blog';
import BlogComment from 'components/admin/views/content/blog/BlogComment';
import BlogSlideSection from 'components/admin/views/content/blog/BlogSlideSection';

import Client from 'components/admin/views/management/Clients';
import Information from 'components/admin/views/management/Information';
import Projects from 'components/admin/views/management/projects/Projects';
import ProjectsFloorPlan from 'components/admin/views/management/projects/ProjectsFloorPlan';

import Product from 'components/admin/views/management/product/Product';
import ProductOptions from 'components/admin/views/management/product/ProductOptions';
import ProductEspecificactions from 'components/admin/views/management/product/ProductEspecificactions';
import ProductHelp from 'components/admin/views/management/product/ProductHelp';
import Category from 'components/admin/views/management/product/Category';

import Filter from 'components/admin/views/management/filters/Filter';
import ProductFilter from 'components/admin/views/management/filters/ProductFilter';
import ProjectFilter from 'components/admin/views/management/filters/ProjectFilter';

import ContactForm from 'components/admin/views/report/ContactForm';

import AboutArtectum from 'components/admin/views/content/AboutArtectum';
import UserRegister from 'components/admin/views/management/UserRegister';

const AdminRoutes = () => (
    <Switch>
        <Route exact path="/admin/content/home-banner-slide" component={HomeBannerSlide} />
        <Route exact path="/admin/content/faq" component={Faq} />
        <Route exact path="/admin/content/home-page" component={HomeItems} />
        <Route exact path="/admin/content/about-artectum" component={AboutArtectum} />

        <Route exact path="/admin/content/blog" component={Blog} />
        <Route exact path="/admin/content/blog/comments" component={BlogComment} />
        <Route exact path="/admin/content/blog/slide-section" component={BlogSlideSection} />

        <Route exact path="/admin/management/information" component={Information} />
        <Route exact path="/admin/management/clients" component={Client} />
        <Route exact path="/admin/management/projects" component={Projects} />
        <Route exact path="/admin/management/projects/projects-detail" component={ProjectsFloorPlan} />

        <Route exact path="/admin/management/product" component={Product} />
        <Route exact path="/admin/management/product/product-options" component={ProductOptions} />
        <Route exact path="/admin/management/product/product-specification" component={ProductEspecificactions} />
        <Route exact path="/admin/management/product/product-help" component={ProductHelp} />
        <Route exact path="/admin/management/product/categories" component={Category} />

        <Route exact path="/admin/management/filters" component={Filter} />
        <Route exact path="/admin/management/filters/product-filters" component={ProductFilter} />
        <Route exact path="/admin/management/filters/project-filters" component={ProjectFilter} />

        <Route exact path="/admin/reports/contact" component={ContactForm} />

        <Route exact path="/admin/content/user-register" component={UserRegister} />

        <Route path="/admin/*">
            <Redirect to="/admin/content/home-banner-slide" />
        </Route>
    </Switch>
);

export default AdminRoutes;